module.exports = __webpack_public_path__ + "media/images/emblems/Oberdorf-coat_of_arms-ec5172c707d2b3bf46499d7f6123705d.svg";